import React from "react";
import './header.css'
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import InfoIcon from '@mui/icons-material/Info';
import AppsIcon from '@mui/icons-material/Apps';
import HomeIcon from '@mui/icons-material/Home';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import { NavLink } from "react-router-dom";
import {FaBars, FaTimes} from "react-icons/fa"
import { useRef } from "react";

export default function Header(){
    const navref = useRef();

    const showNavbar = () =>{
        navref.current.classList.toggle("responsive_nav");
    }    

    return(        
        <header>   
                <nav ref={navref}>
                        <NavLink to="./" className="button" onClick={showNavbar}>
                                <span class="icon"><HomeIcon/></span>
                                <span class="text">Home</span>
                        </NavLink>   
                
                        <NavLink to="./about_me" className="button" onClick={showNavbar}>
                                <span class="icon"><InfoIcon/></span>
                                <span class="text">About Me</span>
                        </NavLink>

                        <NavLink to="./skills" className="button" onClick={showNavbar}>
                                <span class="icon"><TipsAndUpdatesIcon/></span>
                                <span class="text">Skills</span>
                        </NavLink>

                        <NavLink to="./projects" className="button" onClick={showNavbar}>
                                <span class="icon"><AppsIcon/></span>
                                <span class="text">Projects</span>
                        </NavLink>

                        <NavLink to="./contactme" className="button" onClick={showNavbar}>
                                <span class="icon"><ContactPhoneIcon/></span>
                                <span class="text">Contact</span>
                        </NavLink>

                        <button className="nav_btn nav_close_btn" onClick={showNavbar}>
                                <FaTimes/>
                        </button>
                </nav>
                <div className="nav_btn_wrapper">
                        <button className="nav_btn"  onClick={showNavbar}>
                                <FaBars/>
                        </button> 
                </div>
                               
                
        </header>
    )
}